// extracted by mini-css-extract-plugin
export var inputRange = "M_cK";